module.exports = __webpack_public_path__ + "static/media/19.7a7b3fa6.png";